import React, { useContext } from 'react';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { Link } from 'react-router-dom';
import logComponent from '../../common/logComponent';

export default function CardLinkReport({ reportId }) {
  const environmentContext = useContext(EnvironmentContext);
  const { selectedUnit, selectedMonitoredIndividual } = environmentContext;
  if (logComponent('CardLinkReport')) { console.debug('CardLinkReport rendered'); }
  return (
    selectedMonitoredIndividual ?
      <Link to={`/monitoredindividual/${selectedMonitoredIndividual.monitoredIndividualId}/reports/${reportId}`}>View report</Link> :
      selectedUnit ?
        <Link to={`/unit/${selectedUnit.unitId}/reports/${reportId}`}>View report</Link> :
        <Link to={`/reports/${reportId}`}>View report</Link>
    );
}
